import React from 'react';

type Props = {
  title?: string;
  className?: string;
  children: React.ReactNode;
};

/** 모달 내에서 제목/항목(텍스트 혹은 폼) 2열 그리드 잡아주는 컴포넌트 */
export default function ModalFormGrid({ title, className, children }: Props) {
  return (
    <div
      className={`grid grid-cols-[117fr_352fr] items-center text-left text-sm font-medium text-apps-coreGrayBlack ${className ?? ''}`}
    >
      <h3 className="text-sm font-medium text-apps-coreGrayBlack">{title}</h3>
      {children}
    </div>
  );
}
